import React from 'react';
import { ThemeProvider } from 'styled-components';
import Layout from './src/components/Layout';
import sezzleTheme from './src/templates/Page/themes';
import { GlobalWrapper } from './src/stylesheets/global';
import '@fontsource/open-sans';
import '@fontsource/comfortaa';
import '@fontsource/nunito-sans';

export const wrapPageElement = ({
  element,
  props,
}) => {
  return (
    props.pageContext.layout
      ? (
        <ThemeProvider theme={sezzleTheme}>
          <GlobalWrapper />
          <Layout>
            {element}
          </Layout>
        </ThemeProvider>
      )
      : (
        <ThemeProvider theme={sezzleTheme}>
          <GlobalWrapper />
          {element}
        </ThemeProvider>
      )
  );
};

// for safari images to render properly
export const onClientEntry = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
};
